export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-950 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            {/* Left: Content */}
            <div className="flex-1 w-full p-8 md:p-12 lg:p-16 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
                随时随地，畅享高清影视
              </h2>
              <p className="text-sm md:text-base text-background-200/80 mb-6 max-w-md mx-auto lg:mx-0 leading-relaxed">
                777影院完美适配手机和平板设备，无需下载APP，打开浏览器即可享受流畅的高清观影体验。收藏本站，随时随地畅享海量影视资源。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-6">
                <div className="flex items-center gap-2 px-4 py-2 bg-background-50/10 rounded-lg border border-background-50/15">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-smartphone-line text-accent-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-background-200 whitespace-nowrap">手机浏览器访问</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-background-50/10 rounded-lg border border-background-50/15">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-tablet-line text-accent-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-background-200 whitespace-nowrap">平板设备适配</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-background-50/10 rounded-lg border border-background-50/15">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-bookmark-line text-accent-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-background-200 whitespace-nowrap">浏览器收藏夹直达</span>
                </div>
              </div>

              <a
                href="#hero"
                className="inline-flex px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
              >
                返回首页开始观影
              </a>
            </div>

            {/* Right: Visual */}
            <div className="flex-1 w-full lg:max-w-md">
              <div className="relative h-64 md:h-80 lg:h-96">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20smartphone%20floating%20in%20dark%20space%20displaying%20cinematic%20movie%20poster%20interface%2C%20warm%20golden%20glow%20around%20screen%2C%20modern%20minimal%20device%2C%20dark%20luxurious%20background%20with%20soft%20bokeh%2C%20premium%20tech%20aesthetic%2C%20no%20text%20on%20screen&width=600&height=800&seq=app-section-visual&orientation=portrait"
                  alt="777影院移动端观影体验"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}